import React, { useState } from 'react';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box
} from '@mui/material';
import { gql, useMutation } from '@apollo/client';
import Swal from 'sweetalert2';
import clientGraphql from '../../../common/apollo-graphql';
import CustomDialog from '../../common/components/CustomDialog';
import ClinicDropdown from '../../common/components/Clinics/ClinicDropdown';

const UpdateReferrerClinicDialog = ({ open, onClose, referral }) => {
  const [referringClinic, setReferringClinic] = useState('');

  const SAVE_REFERRAL = gql`
    mutation SaveReferral($params: String!) {
      save_referral(params: $params)
    }
  `;

  const [saveReferral] = useMutation(SAVE_REFERRAL, {
    client: clientGraphql
  });

  const handleSave = async () => {
    try {
      const payload = {
        uuid: referral?.referral?.id,
        status: referral?.referral?.status,
        referral: {
          referrerClinic: referringClinic
        },
      };

      await saveReferral({
        variables: {
          params: JSON.stringify(payload),
        },
      });

      Swal.fire({
        icon: 'success',
        text: 'Referral saved!',
        showConfirmButton: true,
      });

      onClose();
    } catch (error) {
      Swal.fire({
        icon: 'error',
        text: error.message || 'Error saving referral!',
        showConfirmButton: true,
      });
    }
  };

  return (
    <CustomDialog open={open} onClose={onClose}>
      <DialogTitle>Update Referral Source</DialogTitle>
      <DialogContent>
        <Box display="flex" flexDirection="column" gap={3} marginTop={3}>
          <ClinicDropdown
            value={referringClinic}
            onChange={(e) => setReferringClinic(e.target.value)}
            label="Referral Source"
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">Cancel</Button>
        <Button onClick={handleSave} variant="contained" color="primary">Save</Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default UpdateReferrerClinicDialog;
